import React from 'react'
import './dashboard.css'

const PaperCard = ({children}) => {
  return (
    <div className='paper-card-box'>
        {children}
    </div>
  )
}

export default PaperCard